import React from "react"
import { CardSelectorProps } from "../types/card"

export const CardSelector = (props: CardSelectorProps) => {

    return (
        <div className="row">
            <div className="col-12">
                <div className="d-flex align-content-stretch flex-wrap">
                    {props.options.map(c => {
                        let className = "card h-100"
                        if (props.selectedOption === c.id) {
                            className += " bg-primary text-white"
                        }
                        return <div key={c.id} className="col-xl-2 col-lg-3 align-self-stretch p-1 no-underline">
                            <a key={c.id} href='#' onClick={() => props.onChangeCallback(c.id)}>
                                <div className={className}>
                                    <div className="card-body px-1">
                                        <h5 className="card-title m-0 p-0 border-0">
                                            <p className="text-center m-0">
                                                {c.icon}
                                            </p>
                                        </h5>
                                        <h6 className="text-center card-title m-0 p-0 border-0">
                                            <small className="m-0 pt-1">
                                                {c.name}
                                            </small>
                                        </h6>
                                    </div>
                                </div>
                            </a>
                        </div>
                    })}
                </div>
            </div>
            <div className="col-12">
                {props.options.map(c => {
                    let className = ""
                    if (props.selectedOption === c.id) {
                        className += " show bg-light col-lg-9 col-xl-6 p-1 mt-1 rounded"
                    } else {
                        className += " d-none"
                    }
                    return <div
                        key={c.id}
                        className={className}
                        id={"list-" + c.id }
                        role="tabpanel"
                        aria-labelledby={"list-" + c.id + "-list"}>
                        <p className="p-2 m-0" >
                            <small>
                                {c.description}
                                <br />
                            </small>
                        </p>
                    </div>
                })}
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/common/card/CardSelector.tsx